<template>
    <div class="handlers">
        <a :href="telephoneAttribute"><span class="fa fa-phone"></span> {{ telephone }}</a>
        <span class="trigger" @click.prevent="expand()">
            <span class="openLabel" v-show="!expanded">OPEN MENU</span>
            <span class="closeLabel" v-show="expanded">CLOSE MENU</span>
            <span class="fa fa-bars"></span>
        </span>
    </div>
</template>
<script>
    export default {
        props: {
            telephone: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                expanded: false
            };
        },
        computed: {
            telephoneAttribute() {
                return 'tel:' + this.telephone.replace(/ /g,'');
            }
        },
        mounted() {
            window.EventHandler.listen('navigation-hidden', () => {
                this.expanded = false;
            });
        },
        methods: {
            expand() {
                this.expanded = !this.expanded;
                window.EventHandler.fire('expand-navigation');
            }
        }
    };
</script>


// WEBPACK FOOTER //
// resources/js/src/components/Navigation/NavigationHandler.vue